export default __webpack_public_path__ + "static/media/Flag_of_Australia.6d8160ad.svg";